export default function SyncHistory() {
  return <div className="coming-soon">Sync History coming soon.</div>;
}
